module.exports = __webpack_public_path__ + "img/2.dea304d8.png";